import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import { styles } from './styles';
import { SxProps, Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

export const BadgeContainer = ({
  children,
  additionalSx,
}: {
  children: ReactNode;
  additionalSx?: SxProps<Theme>;
}) => {
  return <Grid sx={[additionalSx as SystemStyleObject<Theme>, styles.scrollbar]}>{children}</Grid>;
};
